var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.loading)?_c('div',{staticClass:"dot-opacity-loader",staticStyle:{"z-index":"5"}},[_c('span'),_c('span'),_c('span')]):_vm._e(),_c('div',{staticClass:"mt-3",staticStyle:{"height":"300px"},attrs:{"id":"sensorChartContainer"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }